export const topicsList = [
  {
    id: 1,
    title: "《春日信笺》定档了！你最期待哪一段剧情？",
    createdAt: "2026-09-29",
    commentCount: 128,
    author: "信笺收藏家",
  },
  {
    id: 2,
    title: "聊聊你心中大岛优香最打动你的一场戏",
    createdAt: "2026-09-24",
    commentCount: 246,
    author: "光影记录者",
  },
  {
    id: 3,
    title: "《慢生活手记》里哪个瞬间让你也想慢下来？",
    createdAt: "2026-09-15",
    commentCount: 87,
    author: "小镇慢生活",
  },
  {
    id: 4,
    title: "如果让你推荐一部作品给新朋友，你会选哪部？",
    createdAt: "2026-09-08",
    commentCount: 173,
    author: "第一次见面",
  },
  {
    id: 5,
    title: "一起为公益项目加油，分享你的艺术启蒙故事",
    createdAt: "2026-08-30",
    commentCount: 64,
    author: "小小的画笔",
  },
  {
    id: 6,
    title: "秋日复古大片太美了，来聊聊你最喜欢的造型",
    createdAt: "2026-08-02",
    commentCount: 95,
    author: "复古衣橱",
  },
];

export const commentsList = [
  {
    id: 1,
    user: "晚风里的信",
    content:
      "看完预告整个人都不淡定了，她那种克制又汹涌的表演真的太有感染力，已经预约好播出第一时间追。",
    date: "2026-09-29",
  },
  {
    id: 2,
    user: "胶片小陈",
    content:
      "《逆光而行》里那个回头看镜头的画面我能看一百遍，什么都没说，但什么都说了。",
    date: "2026-09-27",
  },
  {
    id: 3,
    user: "海边的猫",
    content:
      "慢生活手记真的治愈，看她认真晒床单的样子，突然觉得生活其实可以很简单。",
    date: "2026-09-25",
  },
  {
    id: 4,
    user: "柠檬气泡水",
    content:
      "从《纸鸢》开始关注她的，一路看着她越走越好，作为老观众真的特别骄傲。",
    date: "2026-09-20",
  },
  {
    id: 5,
    user: "安安的日记",
    content:
      "公益项目这条新闻看得我好感动，愿意把注意力放到乡村孩子身上，真的很温柔。",
    date: "2026-09-16",
  },
  {
    id: 6,
    user: "老书店的灯",
    content:
      "希望以后能出更多幕后花絮，想看她准备角色时的样子，感觉比正片还有意思。",
    date: "2026-09-11",
  },
];